import React from 'react';
import { useAuth } from '../../../../AuthContext';

/**
 * Shown to signed-in users with no verified brand (absorbed the old
 * NoBrandNotice card). Brand self-creation comes later; for now the team
 * connects accounts to brands manually.
 */
const NoBrandBlock: React.FC = () => {
  const { user } = useAuth();
  return (
    <div
      className="tend-surface tend-f1"
      style={{ borderRadius: 14, padding: '14px 16px' }}
    >
      <div className="tend-micro" style={{ marginBottom: 6 }}>
        Signed in as {user?.email}
      </div>
      <div
        style={{
          fontFamily: "'Inter Tight', sans-serif",
          fontWeight: 700,
          fontSize: 14.5,
          color: 'var(--text)',
          marginBottom: 4,
        }}
      >
        No brand connected yet
      </div>
      <div style={{ fontSize: 13, lineHeight: 1.55, color: 'var(--text-2)' }}>
        Your account isn&apos;t connected to a brand yet — we&apos;re setting
        that up for you. You&apos;ll get access as soon as it&apos;s ready.
      </div>
    </div>
  );
};

export default NoBrandBlock;
